import FinancialTableHeader from './FinancialTableHeader';

export default FinancialTableHeader;
